<template>
  <div id="videoRoom" v-loading="loading" element-loading-text="视频加载中..."
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <div v-if="isTencent">
      <remote-js cdn="https://web.sdk.qcloud.com/player/tcplayerlite/release/v2.4.1/TcPlayer-2.4.1.js"
        @load-js-finish="this.remoteLoadCallBack"></remote-js>
    </div>
    <div v-else-if="videoData.sourceType === 2 || (isCamp && videoData.liveData)">
      <remote-js cdn="//assorted.sunlands.com/slive-pc/1.17.3/sunlands-live.js"
        @load-js-finish="this.remoteLoadCallBack"></remote-js>
      <remote-css cdn="//assorted.sunlands.com/slive-pc/1.17.3/sunlands-live.css"></remote-css>
    </div>
    <evaluate v-if="loadEvaluate" :isShowEvaluate="isShowEvaluate" @closeEvaluate="closeEvaluate"
      :evaluateInfo="evaluateInfo" @stopTimer="stopTimer"></evaluate>
    <el-dialog :visible.sync="dialogQuestionVisible" :close-on-click-modal="false" :close-on-press-escape="false"
      :show-close="false" top="35vh" width="350px">
      <div slot="title">
        <p style="text-align: center;">请选择答案</p>
      </div>
      <el-radio-group v-model="radio" v-if="questionInfo.qtype === 1">
        <el-radio :label="optionName[index - 1]" v-for="index of questionInfo.optionCount" :key="index">
          {{ optionName[index - 1] }}
        </el-radio>
      </el-radio-group>
      <el-checkbox-group v-model="checkList" v-else>
        <el-checkbox :label="optionName[index - 1]" v-for="index of questionInfo.optionCount" :key="index">
          {{ optionName[index - 1] }}
        </el-checkbox>
      </el-checkbox-group>
      <div slot="footer" class="dialog-footer">
        <el-button @click="emptyAnswer" size="mini">跳 过</el-button>
        <el-button type="primary" :disabled="!isAnswer" @click="submitQuestion" size="mini">
          提 交
        </el-button>
      </div>
    </el-dialog>
    <el-dialog custom-class="result-dialog" :visible.sync="dialogResultVisible" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false" top="35vh" width="450px">
      <div slot="title" :class="[
        'dialog-title',
        resultData.selfAnswer.answer == resultData.selfAnswer.right_answer ||
          resultData.selfAnswer.right_answer == ''
          ? 'success'
          : 'error',
      ]">
        <div style="display: inline;" v-if="resultData.selfAnswer.right_answer != ''">
          <span v-if="
            resultData.selfAnswer.answer == resultData.selfAnswer.right_answer
          ">
            回答正确
          </span>
          <span v-else>回答错误</span>
          &nbsp; &nbsp; &nbsp; &nbsp;
        </div>

        <span class="font-size-14" v-if="resultData.selfAnswer.right_answer != ''">
          正确答案：{{ resultData.selfAnswer.right_answer }}
        </span>
        &nbsp; &nbsp;
        <span class="font-size-14">
          您的答案：{{ resultData.selfAnswer.answer }}
        </span>
      </div>
      <div>
        <p class="options-tips">各选项选中比例</p>
        <div class="ratio-list" v-for="item in resultData.stat" :key="item.answer">
          <span>{{ item.answer }}</span>
          <el-progress :percentage="item.rate" :stroke-width="8" :color="item.isRight ? '#67c23a' : '#909399'">
          </el-progress>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogResultVisible = false">
          继续上课
        </el-button>
      </div>
    </el-dialog>
    <div class="header">
      <div class="header-l">
        <section class="catalogue" @mouseleave="onCatalogue" @mouseenter="onCatalogue">
          <div class="icon-catalogue">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <p>目录</p>
          <div class="catalogue-list scroll-bar" v-show="isCatalogue" ref="catalogueList">
            <div class="item" v-if="isCamp == 1">
              <p class="chapter">
                {{ videoData.courses && videoData.courses.title }}
              </p>
              <div class="knobble-box">
                <p :class="['knobble', item.id == courseId && 'active']"
                  v-for="item in videoData.courses && videoData.courses.courses" :key="item.id"
                  @click="enterRoom(item.id, item.course_type)">
                  {{ item.course_name }}
                </p>
              </div>
            </div>
            <div v-else>
              <div class="item" v-for="item in videoData.courses" :key="item.id">
                <p class="chapter">{{ item.title }}</p>
                <div class="knobble-box">
                  <p :class="['knobble', knobble.id == courseId && 'active']" v-for="knobble in item.courses"
                    :key="knobble.id" @click="enterRoom(knobble.id, knobble.course_type)">
                    {{ knobble.course_name }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div>{{ videoData.title }}</div>
      </div>
      <div class="header-r">
        <img class="room-avatar" :src="userInfo.avatar" alt="" />
        <p>{{ userInfo.nickname || userInfo.name || userInfo.tel }}</p>
      </div>
    </div>

    <iframe v-if="isLivePro" class="iframeBox" :src="liveProUrl" frameborder="0"></iframe>
    <div class="container" ref="container" v-else>
      <div class="container-l">
        <div id="player" class="player_box" ref="player_box"></div>
        <div class="not-started" v-if="isBegin">
          <div class="course-img-status">
            <img src="../../assets/images/icons/icon-player.png" alt="" />
            <p>{{ courseStatusMsg }}</p>
          </div>
        </div>
        <div v-if="!isTencent" class="switch-video" @click="switchVideoWindow">
          <img src="../../assets/images/icons/icon-switch-video.png" alt="" />
          <p>切换窗口</p>
        </div>
      </div>
      <div class="container-r" :style="{ paddingTop: isTencent ? 0 : '225px' }">
        <div class="course-evaluate" v-if="isShowFloatingWindow">
          <img class="course-evaluate-close" src="../../assets/images/close.png" alt="" @click="closeEvaluateBox" />
          <img class="course-evaluate-img" src="../../assets/images/course-evaluate.png" alt="" @click="openEvaluate" />
        </div>
        <div class="icon-question" v-if="isShowEnterQuestion">
          <img class="course-evaluate-img" src="../../assets/images/icon-question.png" alt=""
            @click="openQuestion(videoData.classexamId)" />
        </div>
        <div v-show="!isTencent" id="camera" class="camera_box" ref="camera_box"></div>
        <div class="chat-box">
          <p class="title">
            {{
                isLive == 1 && videoData.interval > 0
                  ? '观看人次 ' + (videoData.currViewNum || 0)
                  : '在线讨论'
            }}
          </p>
          <p class="hint">
            温馨提示：观看回放时无法发表讨论，如有问题请在直播过程中与讲师沟通
          </p>
          <div class="chat-content scroll-bar" ref="chatContent">
            <div class="chat-list">
              <div class="item" v-for="(item, index) in chatList" :key="index">
                <p v-if="item.type !== 1">
                  <span v-if="item.user_identity === 1 || item.role === 1" class="study">
                    {{ item.user_name || item.name }}
                  </span>
                  <span v-else class="teacher study">
                    {{
                        (item.user_name || item.name) +
                        '[' +
                        (item.user_identity === 2 || item.role === 2
                          ? '老师'
                          : '助教') +
                        ']'
                    }}
                  </span>
                  <span>{{ item.message_content || item.content }}</span>
                </p>
                <p class="hint-message" v-else>
                  <span>{{ item.message_content }}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="send-box">
            <input type="text" placeholder="请输入..." v-model="message" @keyup.enter="sendMessage" :disabled="!isStart" />
            <el-button type="primary" @click="sendMessage" :disabled="!isStart">
              发言
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <el-drawer title="随堂考" :visible.sync="drawer" size="70%" class="zoom-question">
      <div class="questions-box">
        <div class="questions" v-for="(item, index) in questionList">
          <div :class="['question-title']">
            <span class="index">{{ index + 1 }}.</span>
            <span class="lable">
              【{{
                  item.questionType === 'JUDGE_CHOICE'
                    ? '判断题'
                    : item.questionType === 'MULTI_CHOICE'
                      ? '多选题'
                      : '单选题'
              }}】
            </span>
            <div class="title" v-html="item.title"></div>
          </div>
          <div>
            <div v-if="
              item.myAnswer.isCorrect == 1 || item.myAnswer.isCorrect == 0
            ">
              <div class="el-radio" v-for="option in item.options" :label="option.optionTitle"
                :key="option.optionTitle">
                <div class="options">
                  <div class="options-item">
                    <span class="result-icon">
                      <img v-if="
                        item.correctAnswer.indexOf(option.optionTitle) != -1
                      " src="../../assets/images/icons/icon-answer-right.png" alt="" />
                      <img v-else-if="item.myAnswer.isCorrect == 0"
                        src="../../assets/images/icons/icon-answer-error.png" alt="" />
                    </span>
                    <span v-if="item.questionType != 'JUDGE_CHOICE'">
                      {{ option.optionTitle }}.&nbsp;
                    </span>
                    <span v-html="option.optionContent"></span>
                  </div>
                </div>
              </div>
            </div>
            <el-radio-group @change="
              changeQuestion($event, item.questionMainId, index, 'adion')
            " v-model="item.myAnswer.answer" v-else-if="
  item.questionType === 'JUDGE_CHOICE' ||
  item.questionType === 'SINGLE_CHOICE'
">
              <el-radio v-for="option in item.options" :label="option.optionTitle" :key="option.optionTitle">
                <div class="options">
                  <div class="options-item">
                    <span v-if="item.questionType != 'JUDGE_CHOICE'">
                      {{ option.optionTitle }}.&nbsp;
                    </span>
                    <span v-html="option.optionContent"></span>
                  </div>
                </div>
              </el-radio>
            </el-radio-group>
            <el-checkbox-group v-else v-model="item.myAnswer.answer">
              <el-checkbox v-for="option in item.options" :label="option.optionTitle" :key="option.optionTitle">
                <div class="options">
                  <div class="options-item">
                    <span>{{ option.optionTitle }}.&nbsp;</span>
                    <span v-html="option.optionContent"></span>
                  </div>
                </div>
              </el-checkbox>
              <el-button :disabled="!(item.myAnswer.answer.length > 0)" style="margin-left: 20px;" type="primary"
                size="mini" @click="addCorrect(index, item.myAnswer.answer, 'checkbox')">
                确定
              </el-button>
            </el-checkbox-group>
          </div>
          <div class="error-right" v-if="item.myAnswer.isCorrect == 1 || item.myAnswer.isCorrect == 0">
            <span class="right" v-if="item.myAnswer.isCorrect == 1">
              回答正确
            </span>
            <span class="error" v-else>回答错误</span>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import {
  getData,
  setCourseLog,
  addQuestion,
  submitQuestion,
  statQuestion,
  getSeriesPaper,
  sumbitSeriesPaper,
} from '@/server/videoRoom'
import Evaluate from '@/components/videoRoom/evaluate'
import { throttle } from '@/utils/utils'
export default {
  inject: ['reload'],
  name: 'videoRoom',
  components: {
    Evaluate,
    'remote-js': {
      render(createElement) {
        return createElement('script', {
          attrs: {
            type: 'text/javascript',
            src: this.cdn,
          },
          on: {
            load: () => {
              this.$emit('load-js-finish')
            },
          },
        })
      },
      props: {
        cdn: {
          type: String,
          required: true,
        },
      },
    },
    'remote-css': {
      render(createElement) {
        return createElement('link', {
          attrs: {
            rel: 'stylesheet',
            type: 'text/css',
            href: this.cdn,
          },
        })
      },
      props: {
        cdn: {
          type: String,
          required: true,
        },
      },
    },
  },
  computed: {
    ...mapGetters(['userInfo']),
    isTencent() {
      return this.videoData.sourceType === 1 && this.isCamp == 2
    },
  },
  data() {
    return {
      isLivePro: false,
      liveProUrl: '',
      courseId: this.$route.query.courseId,
      isCamp: this.$route.query.type, //1: 训练营 2：系列课
      loadEvaluate: false,
      isShowEvaluate: false,
      isShowEnterQuestion: false,
      isShowFloatingWindow: false,
      isCatalogue: false,
      isStart: false, //是否可以聊天
      buffer: false,
      isBegin: false, //课程是否开始
      dialogQuestionVisible: false,
      dialogResultVisible: false,
      isFull: false,
      switchVideo: false,
      isAnswer: false,
      drawer: false,
      isLoadingJS: false,
      loading: true,
      playerData: {
        debug: false, // sdk内部日志开关
        liveData: {},
        sketchpad: {
          el: 'player',
          ready: (sketchpad) => {
            this.sketchpadEvent = sketchpad
          },
        },
        camera: {
          el: 'camera',
          swfPath: './static/sunlands_player.swf',
          ready: (camera) => {
            this.cameraEvent = camera
            if (this.videoData.defaultScreen === 1) {
              this.switchVideoWindow()
            }
          },
          onExitFullScreen: function () {
            // 播放器退出全屏的回调，返回true/fase则阻止/执行默认的退出全屏操作
            this.isFull = false
          },
          onFullScreen: () => {
            // 播放器进入全屏的回调，返回true/fase则阻止/执行默认的全屏操作
            this.isFull = true
          },
          notInitPlayerService: false, // 是否不初始化播放器服务 默认为false，即默认初始化(在1.16.2以上及1.12.1进行支持)
        },
        chat: {
          // 聊天
          ready: (chat) => {
            this.chatEvent = chat
            if (this.isLive == 0) {
              this.chatEvent.loadAllMessages((res) => {
                const { message_list } = res
                const { courseType, status, messageList } = this.videoData
                if (courseType === 3 && status === 4) {
                  this.chatList = messageList
                }
                if (this.videoData.courseType !== 3) {
                  this.chatList = message_list
                }
              })
            }
          },
          notInitChatService: false, // 是否不初始化聊天服务 默认为false，即默认初始化(在1.16.2以上及1.12.1进行支持)
        },
      },
      videoData: {},
      createPlayerParams: {},
      evaluateInfo: {
        courseId: this.$route.query.courseId,
        title: '',
        starNum: 5,
        evaluateTags: {},
        comment: '',
        status: true,
      },
      chatList: [],
      message: '',
      live: null,
      replay: null,
      chatEvent: null,
      sketchpadEvent: null,
      cameraEvent: null,
      evaluateTimer: null,
      peopleTimer: null,
      questionId: null,
      liveProTime: null,
      currentTime: 0,
      step: 0,
      isLive: 0,
      courseStatusMsg: '',
      optionName: ['A', 'B', 'C', 'D', 'E', 'F', 'G'],
      radio: '',
      checkList: [],
      questionList: [],
      questionInfo: {},
      resultData: {
        selfAnswer: {},
      },
      onTimeShow: null,
    }
  },
  mounted() {
    this.setCatalogueHeight()
    this.getData()
  },
  beforeDestroy() {
    clearTimeout(this.evaluateTimer)
    clearInterval(this.peopleTimer)
    clearInterval(this.onTimeShow)
    clearInterval(this.liveProTime)
    this.isShowEvaluate = true
  },
  watch: {
    step: async function (newVal, oldVal) {
      if (newVal % 60 === 0) {
        let params = {}
        params.currentTime = this.currentTime
        params.isLive = this.isLive
        params.type = this.isCamp
        params.shuidiId = this.videoData.shuidiId
        params.courseId = this.courseId
        await setCourseLog('?r=course-log/log', params)
      }
    },
    radio(newVal, oldVal) {
      this.isAnswer = true
    },
    checkList(newVal, oldVal) {
      if (newVal.length === 0) {
        this.isAnswer = false
      } else {
        this.isAnswer = true
      }
    },
  },
  methods: {
    onTimeQuestion() {
      this.onTimeShow = setInterval(() => {
        let timestamp = new Date().getTime(),
          questionStart = new Date(
            this.videoData.classexamShowStartTime,
          ).getTime()
        // questionEnd = new Date(this.videoData.classexamShowEndTime).getTime();
        if (timestamp >= questionStart) {
          this.isShowEnterQuestion = true
          clearInterval(this.onTimeShow)
        }
        // if (timestamp > questionEnd) {
        // this.isShowEnterQuestion = false;

        // }
      }, 1000)
    },
    changeQuestion(e, id, i, type) {
      sumbitSeriesPaper('?r=series-paper/class-exam-submit', {
        courseId: this.courseId,
        stuId: this.videoData.shuidiId,
        paperId: this.videoData.classexamId,
        questionMainId: id,
        answer: e,
      })
      if (type == 'checkbox') {
        return
      }
      this.addCorrect(i, e)
    },
    addCorrect(i, answer, type) {
      let myAnswer = answer
      if (answer instanceof Array) {
        myAnswer = Array.from(answer).sort().join('')
      }
      if (myAnswer.indexOf(this.questionList[i].correctAnswer) != -1) {
        this.questionList[i].myAnswer.isCorrect = 1
      } else {
        this.questionList[i].myAnswer.isCorrect = 0
      }
      if (type === 'checkbox') {
        this.changeQuestion(
          myAnswer,
          this.questionList[i].questionMainId,
          i,
          'checkbox',
        )
      }
    },
    openQuestion(classexamId) {
      getSeriesPaper('?r=series-paper/class-exam-enter', {
        courseId: this.courseId,
        paperId: classexamId,
      }).then((res) => {
        this.drawer = true
        const { code, data, msg } = res
        if (code === 0) {
          this.questionList = data.questionList.map((item) => {
            if (item.myAnswer instanceof Array) {
              item.myAnswer = {}
              item.myAnswer.answer = []
              item.myAnswer.isCorrect = null
            }
            return item
          })
        }
      })
    },
    /**
     * 设置目录高度
     */
    setCatalogueHeight() {
      this.$refs.catalogueList.style.height =
        18 + this.$refs.container.clientHeight + 'px'
    },
    remoteLoadCallBack() {
      this.isLoadingJS = true
      this.createVideoPlayer()
    },
    createVideoPlayer() {
      // 腾讯云
      if (this.isCamp == 2 && this.videoData.sourceType === 1) {
        this.createTencentPlayer()
      }
      // 尚直播
      else {
        this.createPlayer(
          this.createPlayerParams.liveData,
          this.createPlayerParams.courseType,
          this.createPlayerParams.status,
        )
      }
      this.loading = false
    },
    switchVideoWindow() {
      if (this.switchVideo) {
        this.switchVideo = false
        this.$refs.player_box.className = 'player_box'
        this.$refs.camera_box.className = 'camera_box'
      } else {
        this.switchVideo = true
        this.$refs.camera_box.className = 'player_box'
        this.$refs.player_box.className = 'camera_box'
      }
      document.querySelector(
        '.player_box .slplayer-content',
      ).onmouseover = function (e) {
        document.querySelector('.player_box .slplayer-content').className +=
          ' slplayer-content-active'
      }
    },
    /**
     * 获取数据
     */
    async getData() {
      if (this.isCamp == 1) {
        var { code, data, msg } = await getData('?r=training-course/enter', {
          courseId: this.courseId,
        })
      } else {
        var { code, data, msg } = await getData('?r=courses/enter', {
          courseId: this.courseId,
        })
      }
      // if(type == 1){
      //     if(sourceType == 1){
      //         //尚直播
      //     }else if(sourceType == 2){
      //         //尚直播Pro
      //     }
      // }else if(type == 2){
      //     if(sourceType == 1){
      //         //腾讯云
      //     }else if(sourceType == 2){
      //         //尚直播
      //     }
      // }


      console.log('===================')
      console.log(data)
      console.log('sourceType ==>>' + data.sourceType)
      console.log('isCamp ==>>' + this.isCamp)
      // isCamp //1: 训练营 2：系列课
      if (code === 0) {
        this.videoData = data
        //教师评价组件参数
        this.evaluateInfo.title = data.title

        if (this.isCamp != 1 && data.isEvaluate === 0) {
          this.loadEvaluate = true
          this.isShowFloatingWindow = true
          this.evaluateCountDown()
          data.evaluateTags.forEach((list) => {
            let obj = list.tags.map((item) => {
              let tags = {}
              tags.name = item
              tags.isSelected = false
              return tags
            })
            this.evaluateInfo.evaluateTags[list.star] = obj
          })
        } else {
          // this.evaluateCountDown();
          // this.evaluateInfo.evaluateTags[data.evaluate.star] = data.evaluate.tags.map(item => {
          //     let tags = {};
          //     tags.name = item;
          //     tags.isSelected = true;
          //     return tags
          // })
          // this.evaluateInfo.starNum = data.evaluate.star;
          // this.evaluateInfo.comment = data.evaluate.comment;
          // this.evaluateInfo.status = false;
        }

        if (this.isCamp == 1 && data.sourceType == 2) {
          // 尚直播pro
          this.isLivePro = true
          let videoType = 'replay'
          if (data.courseType === 1) { // courseType  1：录播  2：直播   3：伪直播
            videoType = 'replay';
          } else if (data.courseType === 2) {
            if (data.status === 4 || data.status === 5) {
              videoType = 'replay';
            } else {
              videoType = 'live';
              this.isLive = 1
            }
          } else {
            // status 1 未开课、2 直播中、3 暂停、 4 已结束（老师已经点击下课，视频已经合并完成）、5 合并中（老师已经点击下课，但视频正在合并中）
            // 尚直播pro 
            // 直播间状态 1：未开始，2：直播中，3：暂停，4：合并中，5：回放生成
            if (data.status === 4 || data.status === 5) {
              videoType = 'replay';
            } else {
              videoType = 'live';
              this.isLive = 1
            }
          }
          let url = `https://smallprogram.yingteach.com/fe-shanglive-v2/v3.0.3/pc/index.html#/${videoType}?liveData={"type":"JWT","payload":"${data.liveData.payload}"}`
          this.liveProUrl = url
          this.loading = false;
          this.isBegin = true;
          clearInterval(this.liveProTime)
          this.liveProTime = setInterval(() => {
            this.step++;
          }, 1000)
        } else {
          if (
            (data.courseType === 1 && data.isBegin === 0) ||
            data.status === 1
          ) {
            this.isBegin = true
            this.courseStatusMsg = '课程未开始~'
            this.loading = false
          } else if (data.status === 5) {
            this.isBegin = true
            this.courseStatusMsg = '回放生成中...'
            this.loading = false
          } else {
            this.createPlayerParams = {
              liveData: data.liveData,
              courseType: data.courseType,
              status: data.status,
            }
            this.loading = false
          }
        }
      } else {
        this.loading = false
        alert('code=>' + msg)
      }
    },

    /**
     * 创建播放器
     * @param { Object } liveData 第三方登录参数
     * @param { Number } type 课程类型 1：录播 2：直播 3：伪直播
     * @param { Number } status 课程状态 4：回放 1、2、3 属于直播状态
     */
    createPlayer(liveData, type, status) {
      this.loading = false
      this.playerData.liveData = liveData
      try {
        if (status === 4) {
          this.replay = new SLIVE.Replay(this.playerData)
          this.changeReplay()
          return
        }
        if (type === 2 && status !== 4) {
          this.isLive = 1
          this.live = new SLIVE.Live(this.playerData)
          this.changeLive()
          return
        }
        if (type == 3) {
          this.isLive = 1
          this.live = new SLIVE.Elive(this.playerData)
          this.changeLive()
        }
      } catch (err) {
        this.$alert('视频加载失败, 请检查您的网络或刷新重新进入课程', '提示', {
          type: 'warning',
          confirmButtonText: '确定',
          callback: (action) => { },
        })
      }
    },

    createTencentPlayer() {
      const _this = this
      const urls = _this.videoData.url[0]
      var player = new TcPlayer('player', {
        mp4: urls.original, //请替换成实际可用的播放地址
        mp4_hd: urls.hd,
        mp4_sd: urls.sd,
        autoplay: true, //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
        width: '100%',
        height: '100%',
        flash: false,
      })

      const setLog = throttle(() => {
        _this.currentTime = player.currentTime()
        _this.step++
      }, 900)
      player.video.on('timeupdate', setLog)
    },

    /**
     * 监听直播，伪直播事件
     */
    changeLive() {
      //是否展示随堂考
      if (
        this.videoData.classexamId &&
        this.videoData.classexamShowType === 1
      ) {
        this.isShowEnterQuestion = true
      }
      if (
        this.videoData.classexamId &&
        this.videoData.classexamShowType === 2
      ) {
        this.onTimeQuestion()
      }
      this.live.on('live:login', (res) => {
        const { iCode } = res
        this.isStart = true
        this.watchingPeople()
      })
      this.live.on('live:error', (err) => {
        console.log(err)
        // alert(err.sError)
      })
      this.live.on('live:end', (data) => {
        clearInterval(this.peopleTimer)
      })
      this.live.on('live:begin', (data) => {
        console.log(data)
      })
      this.live.on('live:pause', (data) => { })
      this.live.on('live:continue', (data) => { })
      this.live.on('live:question_start', async (data) => {
        if (this.isFull) this.exitFullscreen()
        this.questionInfo = data
        this.dialogResultVisible = false
        this.dialogQuestionVisible = true
        this.questionId = await this.addQuestionServer(data)
      })
      this.live.on('live:question_end', (data) => {
        this.dialogQuestionVisible = false
        let randomNum = Math.ceil(Math.random() * 5)
        setTimeout(async () => {
          this.resultData = await this.answerResults()
          if (this.resultData.submitted) {
            this.dialogResultVisible = true
          }
        }, randomNum * 1000)
      })
      this.live.on('live:video_type_change', (data) => { })
      this.live.on('live:user_enter', (data) => {
        console.log(data)
      })
      this.live.on('live:heartbeat', (data) => {
        console.log('heartbeat', data)
      })
      this.live.on('live:kicked', (data) => {
        console.log(data)
      })
      this.live.on('camera:time_update', (res) => {
        const { timestamp, currentTime } = res
        this.step++
      })
      this.live.on('chat:login', (res) => {
        const { result, data } = res
        if (result === 0) {
          if (data.forbiddenStatus === 1) {
            this.addHintMessage('全体已被禁言')
          }
          if (data.forbiddenStatusSingle === 1) {
            this.addHintMessage('你已经被禁言')
          }
        }
      })
      this.live.on('chat:send_message_status', (res) => {
        const { cmd, data, result } = res
        switch (result) {
          case 0:
            this.addMessage(data.msgData, data.userIdentity, data.name)
            this.message = ''
            break
          case 6:
            this.addHintMessage('全体已被禁言')
            break
          case 7:
            this.addHintMessage('存在违规词，请重新编辑')
            break
          case 13:
            this.addHintMessage('消息超过长度限制(140汉字)')
            break
          case 14:
            this.addHintMessage('发送太频繁了')
            break
          default:
            this.addHintMessage('发送失败')
        }
      })
      this.live.on('chat:receive_message', (res) => {
        const { cmd, data, result } = res
        console.log(res)
        if (data.displayMode === 1) {
          return
        }
        this.addMessage(data.msgData, data.userIdentity, data.name)
      })
      this.live.on('chat:user_speaking_status', (res) => {
        const { cmd, data } = res
        if (cmd === 0 && data.status === 1) {
          this.addHintMessage('你已经被禁言')
        } else {
          this.addHintMessage('已解除禁言')
        }
      })
      this.live.on('chat:room_speaking_status', (res) => {
        const { cmd, data } = res
        if (cmd === 8 && data.status === 1) {
          this.addHintMessage('全体已被禁言')
        } else {
          this.addHintMessage('已解除全体禁言')
        }
      })
    },

    /**
     * 监听点播事件
     */
    changeReplay() {
      //是否展示随堂考
      if (this.videoData.classexamReplayShow === 1) {
        this.isShowEnterQuestion = true
      }
      this.replay.on('camera:play', () => { })
      this.replay.on('camera:pause', () => { })
      this.replay.on('camera:error', (err) => {
        console.log(err)
        // alert(err)
      })
      this.replay.on('camera:time_update', (res) => {
        const { currentTime } = res
        this.currentTime = currentTime
        this.step++
      })
    },

    /**
     * 发送消息
     */
    sendMessage() {
      if (!this.isStart) {
        return
      }
      if (this.message.match(/^[ ]*$/)) {
        return
      }
      this.chatEvent.sendMessage(this.message)
    },

    /**
     * 添加聊天消息
     * @param { String } msgData 消息文案
     * @param { Number } userIdentity 发送身份--1：学生 2： 老师 3： 助教"
     * @param { String } name 发送人名称
     */
    addMessage(msgData = '', userIdentity = 1, name = '') {
      let obj = {}
      obj.user_identity = userIdentity
      obj.message_content = msgData
      obj.user_name = name
      this.changeChatBoxBottom(obj)
    },

    /**
     * 添加提示消息
     * @param { Number } type 提示消息
     * @param { String } msgData 提示文案
     */
    addHintMessage(msgData, type = 1) {
      let obj = {}
      obj.type = type
      obj.message_content = msgData
      this.changeChatBoxBottom(obj)
    },

    /**
     * 新消息始终在底部展示
     * @param { Object } data 最新消息
     */
    changeChatBoxBottom(data) {
      this.chatList.push(data)
      this.$nextTick(() => {
        let msg = this.$refs.chatContent // 获取对象
        msg.scrollTop = msg.scrollHeight // 滚动高度
      })
    },

    /**
     * 是否打开目录
     */
    onCatalogue() {
      if (this.isCatalogue) {
        this.isCatalogue = false
      } else {
        this.isCatalogue = true
      }
    },

    /**
     * 进入直播间
     * @param { Number } id 课程id
     * @param { Number } type 课程类型
     */
    enterRoom(id, type) {
      if (this.courseId == id) {
        return
      }
      this.$router.push({
        name: 'videoRoom',
        query: {
          courseId: id,
          type: this.isCamp,
        },
      })
      this.reload()
    },

    /**
     * 关闭老师评论
     */
    closeEvaluate() {
      this.isShowEvaluate = false
    },

    /**
     * 关闭评价浮窗
     */
    closeEvaluateBox() {
      this.isShowFloatingWindow = false
    },

    /**
     * 打开老师评价
     */
    openEvaluate() {
      this.isShowEvaluate = true
    },

    /**
     * 老师评价弹框倒计时
     */
    evaluateCountDown() {
      this.evaluateTimer = setTimeout(() => {
        this.isShowEvaluate = true
      }, 3600000)
    },

    /**
     * 停止课程评价倒计时
     */
    stopTimer() {
      clearTimeout(this.evaluateTimer)
    },

    /**
     * 提交问题到尚直播
     */

    async submitQuestion() {
      let answer = this.radio
      if (this.questionInfo.qtype === 2) {
        answer = this.checkList.sort().join('')
      }
      let params = {
        lSequence: new Date().getTime(),
        answer: answer,
      }
      console.log(params)
      this.submitKandianServer(answer)
      this.live.saveAnswer(params)
      this.emptyAnswer()
    },

    /**
     * 清空答案
     */
    emptyAnswer() {
      this.dialogQuestionVisible = false
      this.radio = ''
      this.checkList = []
      this.isAnswer = false
    },

    /**
     * 退出全屏
     */
    exitFullscreen() {
      var de = document
      if (de.exitFullscreen) {
        de.exitFullscreen()
      } else if (de.mozCancelFullScreen) {
        de.mozCancelFullScreen()
      } else if (de.webkitCancelFullScreen) {
        de.webkitCancelFullScreen()
      }
    },

    /**
     * 后台添加题目
     * @param { Object } info 尚直播题目信息
     */
    async addQuestionServer(info) {
      const { code, data, msg } = await addQuestion(
        '?r=exam/tmp-question/add-question',
        {
          courseId: this.courseId,
          type: this.isCamp,
          answersSeq: this.optionName.slice(0, info.optionCount).toString(),
          questionSeq: info.lSequence,
          rightAnswer: info.answer,
        },
        'POST',
      )
      if (code === 0) {
        return data.id
      } else {
        this.$message.error(msg)
      }
    },

    /**
     * 提交问题到看点服务器
     */
    async submitKandianServer(answer) {
      const { code, data, msg } = await submitQuestion(
        '?r=exam/tmp-question/answer',
        {
          questionId: this.questionId,
          answer: answer,
        },
        'POST',
      )
      if (code !== 0) {
        this.$message.error(msg)
      }
    },

    /**
     * 学员答题结果
     */
    async answerResults() {
      const { code, msg, data } = await statQuestion(
        '?r=exam/tmp-question/stat',
        {
          questionId: this.questionId || this.videoData.tmpQuestionId,
        },
      )
      if (code === 0) {
        return data
      } else {
        this.$message.error(msg)
      }
      clearTimeout(this.evaluateTimer)
    },

    watchingPeople() {
      const { increment, interval } = this.videoData
      this.peopleTimer = setInterval(() => {
        this.videoData.currViewNum += increment
      }, interval * 60000)
    },
  },
}
</script>
<style lang="scss">
@media only screen and (min-device-width: 768px) and (max-device-width: 1200px) {
  .slplayer-progress{
    height: 22px !important;
    .slplayer-progress-bar{
      height: 22px !important;

    }
    .slplayer-progress-bar__dot{
      width: 25px;
      height: 25px;
    }
  }

}

</style>

<style lang="scss" scoped>
@import '@/assets/css/style.scss';

.course-evaluate {
  position: absolute;
  top: 328px;
  right: 45px;
  z-index: 10;
  cursor: pointer;

  .course-evaluate-img {
    width: 80px;
  }

  .course-evaluate-close {
    position: absolute;
    top: -10px;
    right: 0;
    z-index: 10;
    width: 12px;
  }
}

.icon-question {
  position: absolute;
  top: 410px;
  right: 45px;
  z-index: 10;
  cursor: pointer;

  .course-evaluate-img {
    width: 100px;
  }
}

#videoRoom {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  height: 100vh;
}

.header,
.container {
  padding: 0 80px;
}

.header {
  width: 100%;
  min-height: 60px;
  background-color: #1d1d1d;
  @include flex-between-and-vertical-center();
  color: #ffffff;

  .header-l,
  .header-r,
  .catalogue {
    @include flex-between-and-vertical-center();
  }

  .header-l,
  .catalogue {
    line-height: 22px;
  }

  .catalogue {
    position: relative;
    cursor: pointer;

    &>p {
      margin: 0 20px 0 10px;
    }
  }

  .catalogue-list {
    position: absolute;
    top: 22px;
    left: -15px;
    z-index: 1900;
    width: 350px;
    background-color: #1a1a1a;
    padding: 37px 30px;
    color: #bbbbbb;
    overflow-x: auto;

    .item {
      margin-bottom: 10px;
    }

    .chapter {
      line-height: 22px;
      margin-bottom: 3px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .knobble-box {
      padding-left: 15px;

      .knobble {
        width: 260px;
        line-height: 32px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        &.active {
          color: #fc8d40;
        }

        &::before {
          content: '';
          display: inline-block;
          width: 16px;
          height: 12px;
          background: url(../../assets/images/icons/icon-video.png) no-repeat center;
          background-size: cover;
          margin-right: 5px;
        }

        &:hover {
          color: #fc8d40;
        }
      }
    }
  }

  .icon-catalogue {
    width: 13px;

    &>span {
      display: block;
      width: 100%;
      height: 2px;
      background-color: #ffffff;
      margin-bottom: 3px;
    }

    &>span {
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .room-avatar {
    width: 38px;
    height: 38px;
    margin-right: 14px;
    border-radius: 100px;
  }
}

.iframeBox {
  min-height: 0;
  flex: auto;
  position: relative;

}

.container {
  min-height: 0;
  flex: auto;
  background-color: #000000;
  position: relative;
  @include flex-between();

  .container-l {
    flex: auto;

    .not-started {
      position: absolute;
      top: 0;
      left: 80px;
      z-index: 100;
      width: calc(100% - 460px);
      height: 100%;
      color: #ffffff;
      text-align: center;
      background-color: #000000;

      .course-img-status {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 100;
        transform: translate(-50%, -50%);
      }

      img {
        width: 297px;
        margin-bottom: 10px;
      }
    }
  }

  .container-r {
    overflow: hidden;
    width: 300px;
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    padding-top: 225px;

    .chat-box {
      flex: auto;
      width: 100%;
      height: calc(100% - 225px);
      background-color: #333333;
      display: flex;
      display: -webkit-flex;
      flex-direction: column;

      .title {
        flex: 0 1;
        height: 52px;
        line-height: 52px;
        border: 1px solid #242424;
        color: #ffffff;
        font-weight: 500;
        text-align: center;
        font-size: 14px;
      }

      .hint {
        flex: 0 1;
        font-size: 12px;
        color: #ffffff;
        padding: 12px 20px;
      }

      .chat-content {
        flex: 1 0;
        overflow-x: auto;
        color: #9b9b9b;
        font-size: 14px;
        padding: 0 10px 0 20px;

        .item {
          margin-bottom: 10px;
          word-wrap: break-word;
        }

        .hint-message {
          text-align: center;
          font-size: 12px;
          height: 24px;
          line-height: 24px;

          &>span {
            padding: 3px 40px;
            border-radius: 10px;
            background-color: rgba($color: #000000, $alpha: 0.3);
          }
        }

        .study {
          color: #ffffff;
          margin-right: 10px;

          &.teacher {
            color: #4a90e2;
          }
        }
      }

      .send-box {
        flex: 0 1;
        width: 100%;
        padding: 0 20px;
        height: 38px;
        @include flex-vertical-center();
        margin: 10px 0;

        &>input {
          // width: 185px;
          flex: 1;
          height: 38px;
          background-color: #1d1d1d;
          border: 0;
          outline: none;
          padding-left: 15px;
          color: #ffffff;
        }

        &>button {
          width: 55px;
          height: 38px;
          padding: 6px 10px;
          border-radius: 0 2px 2px 0;
        }
      }
    }
  }
}

.scroll-bar {
  &::-webkit-scrollbar {
    width: 10px;
    background-color: #1d1d1d;
    border-radius: 6px;
  }

  &::-webkit-scrollbar-button {
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background-color: #4b4b4b;
  }
}

#camera,
#player {
  transition: all 0.32s linear;
}

.switch-video {
  position: absolute;
  bottom: 5px;
  right: 400px;
  color: #ffffff;
  cursor: pointer;
  font-size: 14px;
  text-align: center;
}

.player_box {
  width: calc(100% - 460px);
  height: calc(100% - 57px);
  position: absolute;
  top: 0;
  right: 380px;
}

.camera_box {
  width: 300px;
  height: 225px;
  position: absolute;
  top: 0;
  right: 80px;
  background-color: #c2c2c2;
}

.dialog-title {
  color: #ffffff;
  font-size: 18px;
  padding: 8px 20px;

  &.success {
    background-color: #67c23a;
  }

  &.error {
    background-color: #f56c6c;
  }

  .font-size-14 {
    font-size: 14px;
  }
}

.options-tips {
  margin-bottom: 10px;
}

.ratio-list {
  width: 100%;
  @include flex-vertical-center();
  margin-bottom: 10px;
  font-size: 16px;

  &>div {
    flex: 1;
    margin-left: 10px;
  }
}

.questions-box {
  padding: 0 20px;
}

.questions {
  margin-bottom: 30px;

  .el-radio,
  .el-checkbox {
    display: flex;
    margin-left: 20px;
    padding: 10px 0;
    white-space: inherit;
    font-size: 16px;
  }

  &>>>.el-checkbox__label {
    font-size: 16px;
  }

  &>>>.el-radio__label {
    font-size: 16px;
  }

  &>>>.el-checkbox__inner {
    width: 16px;
    height: 16px;
  }

  &>>>.el-radio__inner {
    width: 16px;
    height: 16px;
  }

  &>>>.el-checkbox__inner {
    &::after {
      top: 2px;
      left: 5px;
    }
  }
}

.error-right {
  display: inline-block;
  font-size: 1px;
  margin-left: 20px;

  span {
    padding: 3px 5px;
    border-radius: 2px;
  }

  .error {
    background: #ffeded;
    color: #f94d48;
  }

  .right {
    background: #e3fbf2;
    color: #23c086;
  }
}

.question-title {
  font-size: 0;
  position: relative;
  font-size: 14px;

  .index,
  .lable,
  .title {
    font-size: 16px;
  }

  .lable {
    flex-shrink: 0;
  }

  .title {
    display: inline;

    &>>>p {
      display: inline;
    }
  }
}

.options {
  display: inline-block;

  .options-item {
    @include flex();

    .result-icon {
      flex-shrink: 0;
      width: 16px;
      margin-right: 10px;
    }
  }
}
</style>
<style lang="scss">
object {
  height: 100% !important;
}

.slplayer-title {
  display: none;
}

// .player_box video {
//   width: 80% !important;
//   height: auto !important;
//   position: absolute;
//   top: 50%;
//   left: 50%;
//   transform: translate(-50%, -50%);
// }
.camera_box .slplayer-content {
  display: none;
}

.result-dialog {
  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 20px 20px;
  }
}

.zoom-question {
  .el-drawer {
    overflow: inherit !important;
  }

  .el-drawer__body {
    overflow-x: auto;
    padding-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/videoRoom/child.vue